import { useFulfillWorkOrder } from '@ztechapps/work-order.common'
import { ShowIf } from '@ztechapps/webui.util'
import includes from 'lodash/includes'
import type { WorkOrder } from '@ztechapps/common.contract'
import { WorkOrderStatusEnum } from '@ztechapps/common.contract'
import type { FunctionComponent } from 'react'
import React from 'react'
import { useConfirmDialog, useError } from '@ztechapps/common.hook'
import type { RowActionMenuProps } from '@ztechapps/webui.data-tools'
import { RowActionMenuButton } from '@ztechapps/webui.data-tools'

export type FulfillWorkOrderButtonProps = {
  As?: FunctionComponent<RowActionMenuProps>
  workOrderId: string
  remarks?: string
  status: string
  afterUpdate?: (workOrder: WorkOrder) => void
}

export const FulfillWorkOrderButton = ({
  As,
  remarks,
  workOrderId,
  status,
  afterUpdate,
}: FulfillWorkOrderButtonProps) => {
  As = As ?? RowActionMenuButton

  const [onFulfill, { loading }] = useFulfillWorkOrder()

  const { onConfirm } = useConfirmDialog({
    title: 'Are you sure you want to complete this production?',
    text: 'This will consume the materials(if any) and update the inventory. This action will lock this production for editing.',
    confirmed: async () => {
      return await onFulfill({
        remarks,
        workOrderId,
      })
    },
  })

  const { onError } = useError()

  const onClick = async () => {
    try {
      const workOrder = await onConfirm()
      afterUpdate?.(workOrder)
    } catch (e) {
      onError(e)
    }
  }

  return (
    <ShowIf condition={includes([WorkOrderStatusEnum.Draft, WorkOrderStatusEnum.InProgress], status)}>
      <As
        isBusy={loading}
        onClick={onClick}
        text="Complete"
        label="Complete this production"
        icon="circle-check"
        className="btn-primary"
      />
    </ShowIf>
  )
}
